import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { FaLinkedin, FaInstagram, FaGithub, FaTwitter, FaMedium } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import '../Socialize.css';

const Socialize = () => {
  const [hoveredIcon, setHoveredIcon] = useState(null);
  const [isDarkTheme, setIsDarkTheme] = useState(true);
  const navigate = useNavigate();

  const designAccounts = [
    { 
      name: 'Figma', 
      url: 'https://www.figma.com/@yourname', 
      description: 'Check out my UI/UX designs and prototypes.',
      logo: 'figma.png',
      color: 'bg-purple-500',
      recentProjects: [
        { name: 'Mobile App UI Kit', url: '#mobile-app-ui-kit' },
        { name: 'Dashboard Design System', url: '#dashboard-design-system' },
        { name: 'E-commerce Redesign', url: '#ecommerce-redesign' }
      ],
      skills: ['UI Design', 'Prototyping', 'Design Systems'],
      bgImageFrontLight: 'https://images.unsplash.com/photo-1496181133206-80ce9b88a853?q=80&w=2071&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',  // Light theme background image
      bgImageBackLight: 'https://images.unsplash.com/photo-1470790376778-a9fbc86d70e2?q=80&w=1904&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',    // Light theme background image
      bgImageFrontDark: 'https://images.unsplash.com/photo-1531297484001-80022131f5a1?q=80&w=2020&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',  // Dark theme background image
      bgImageBackDark: 'https://images.unsplash.com/photo-1721332149371-fa99da451baa?q=80&w=1936&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDF8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D'    // Dark theme background image
    },
    { 
      name: 'Framer', 
      url: 'https://framer.com/@yourname', 
      description: 'Explore my interactive prototypes and animations.',
      logo: 'framer.png',
      color: 'bg-blue-500',
      recentProjects: [
        { name: 'Interactive Landing Page', url: '#interactive-landing-page' },
        { name: 'Animated Onboarding Flow', url: '#animated-onboarding-flow' },
        { name: 'Product Showcase', url: '#product-showcase' }
      ],
      skills: ['Interaction Design', 'Animation', 'Prototyping'],
      bgImageFrontLight: 'https://images.unsplash.com/photo-1455849318743-b2233052fcff?q=80&w=2069&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',  // Light theme background image
      bgImageBackLight: 'https://images.unsplash.com/photo-1470790376778-a9fbc86d70e2?q=80&w=1904&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',    // Light theme background image
      bgImageFrontDark: 'fram.jpg',  // Dark theme background image
      bgImageBackDark: 'fram2.jpg'    // Dark theme background image
    },
    { 
      name: 'Webflow', 
      url: 'https://webflow.com/@yourname', 
      description: 'See my web designs and no-code projects.',
      logo: 'webflow.png',
      color: 'bg-teal-500',
      recentProjects: [
        { name: 'Portfolio Website', url: '#portfolio-website' },
        { name: 'Agency Landing Page', url: '#agency-landing-page' },
        { name: 'Blog Template', url: '#blog-template' }
      ],
      skills: ['Web Design', 'No-Code', 'CMS'],
      bgImageFrontLight: 'https://images.unsplash.com/photo-1499951360447-b19be8fe80f5?q=80&w=2070&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',  // Light theme background image
      bgImageBackLight: 'https://images.unsplash.com/photo-1470790376778-a9fbc86d70e2?q=80&w=1904&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',    // Light theme background image
      bgImageFrontDark: 'webf.jpg',  // Dark theme background image
      bgImageBackDark: 'webf.jpg'    // Dark theme background image
    },
  ];
  
  
  
  const DesignCard = ({ name, url, description, logo, color, recentProjects, skills, bgImageFrontLight, bgImageBackLight, bgImageFrontDark, bgImageBackDark }) => {
    const [isFlipped, setIsFlipped] = useState(false);
    const [isHovered, setIsHovered] = useState(false);
  
    const bgImageFront = isDarkTheme ? bgImageFrontDark : bgImageFrontLight;
    const bgImageBack = isDarkTheme ? bgImageBackDark : bgImageBackLight;
  
    return (
      <motion.div
        className={`h-80 w-full perspective-1000 ${isDarkTheme ? 'text-white' : 'text-black'}`}
        onMouseEnter={() => setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
        onClick={() => setIsFlipped(!isFlipped)}
      >
        <motion.div
          className="w-full h-full relative preserve-3d cursor-pointer"
          animate={{ rotateY: isFlipped ? 180 : 0 }}
          transition={{ duration: 0.6 }}
        >
          {/* Front of the card */}
          <div 
            className={`absolute w-full h-full backface-hidden rounded-lg shadow-md ${isDarkTheme ? 'bg-gray-800' : 'bg-gray-100'} p-6`}
            style={{ backgroundImage: `url(${bgImageFront})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
          >
            <div className={`absolute top-4 right-4 w-12 h-12 rounded-full flex items-center justify-center ${color}`}>
              <img src={logo} alt={`${name} logo`} className="w-10 h-10"/>
            </div>
            <h3 className="text-2xl font-semibold mb-3">{name}</h3>
            <p className="text-sm mb-4">{description}</p>
            <div className="absolute bottom-4 left-4 right-4">
              <motion.p 
                className="text-purple-500 text-sm"
                animate={{ opacity: isHovered ? 1 : 0 }}
                transition={{ duration: 0.3 }}
              >
                Click to see more details
              </motion.p>
            </div>
          </div>
  
          {/* Back of the card */}
          <div 
            className={`absolute w-full h-full backface-hidden rounded-lg shadow-md ${isDarkTheme ? 'bg-gray-800' : 'bg-gray-100'} p-6 rotate-y-180`}
            style={{ backgroundImage: `url(${bgImageBack})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
          >
            <h4 className="text-xl font-semibold mb-3">Recent Projects</h4>
            <ul className="list-disc list-inside text-sm space-y-2 mb-4">
              {recentProjects.map((project, index) => (
                <li key={index}>
                  <a href={project.url} className="text-purple-500 hover:underline">{project.name}</a>
                </li>
              ))}
            </ul>
            <div className="absolute bottom-4 left-4 right-4">
              <a
                href={url}
                target="_blank"
                rel="noopener noreferrer"
                className={`block text-center px-4 py-2 rounded ${isDarkTheme ? 'bg-purple-600 hover:bg-purple-700' : 'bg-purple-500 hover:bg-purple-600'} text-white transition-colors duration-300`}
                onClick={(e) => e.stopPropagation()}
              >
                Visit {name} Profile
              </a>
            </div>
          </div>
        </motion.div>
  
        {/* Floating skill tags */}
        {skills.map((skill, index) => (
          <motion.div 
            key={index}
            className={`absolute top-2 gap-3 ${index === 0 ? 'left-2' : index === 1 ? 'left-24' : 'right-2'} ${color} text-white text-xs px-2 py-1 rounded`}
            animate={{ y: isHovered ? -10 : 0, opacity: isHovered ? 1 : 0 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
          >
            {skill}
          </motion.div>
        ))}
      </motion.div>
    );
  };
  
  
  
  
  
  
  
  
  

  const socialLinks = [
    { name: 'LinkedIn', icon: FaLinkedin, url: 'https://www.linkedin.com/in/singh07digvijay/', color: '#0077B5' },
    { name: 'Instagram', icon: FaInstagram, url: 'https://www.instagram.com/panwar.digvijaysingh/?hl=en', color: '#E1306C' },
    { name: 'GitHub', icon: FaGithub, url: 'https://github.com/Digvijay2347', color: '#333' },
    { name: 'Twitter', icon: FaTwitter, url: 'https://twitter.com/YourTwitter', color: '#1DA1F2' },
    { name: 'Medium', icon: FaMedium, url: 'https://medium.com/@YourMedium', color: '#00AB6C' },
  ];

  const handleClose = () => {
    navigate('/', {replace:true });
  };

  const toggleTheme = () => {
    setIsDarkTheme(!isDarkTheme);
  };

  return (
    <div className={`min-h-screen flex flex-col items-center p-4 sm:p-8 ${isDarkTheme ? 'bg-black text-white' : 'bg-white text-black'} relative overflow-hidden transition-colors duration-300`}>
      <div className="w-full max-w-4xl mx-auto relative">
        <button className="button absolute top-0 left-0 z-20" onClick={handleClose}>
          <span className="X"></span>
          <span className="Y"></span>
          <div className="close">Close</div>
        </button>

        {/* Theme toggle button */}
        <label className="switch absolute top-0 right-0 z-20">
          <input className="cb" type="checkbox" checked={isDarkTheme} onChange={toggleTheme} />
          <span className="toggle">
            <span className="left">off</span>
            <span className="right">on</span>
          </span>
        </label>
      </div>

      <div className="z-10 flex flex-col items-center w-full max-w-4xl mx-auto mt-16 sm:mt-24">
        <motion.h1 
          className={`text-4xl sm:text-6xl md:text-8xl font-bold uppercase mb-4 sm:mb-8 new-amsterdam-regular text-center ${isDarkTheme ? 'text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-pink-600' : 'text-black'}`}
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          Let's Socialize!
        </motion.h1>

        <motion.p 
          className="text-lg sm:text-xl md:text-2xl mb-8 sm:mb-12 text-center max-w-2xl px-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          Connect with me on my social platforms to stay updated and see what I'm working on.
        </motion.p>
        <div className="flex flex-wrap justify-center gap-4 sm:gap-8 mb-8 sm:mb-12">
          {socialLinks.map((link, index) => (
            <motion.div
              key={link.name}
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5 + index * 0.1, duration: 0.5 }}
            >
              <a 
                href={link.url} 
                target="_blank" 
                rel="noopener noreferrer"
                onMouseEnter={() => setHoveredIcon(link.name)}
                onMouseLeave={() => setHoveredIcon(null)}
              >
                <motion.div
                  whileHover={{ scale: 1.2 }}
                  whileTap={{ scale: 0.9 }}
                >
                  <link.icon 
                    size={40} 
                    color={hoveredIcon === link.name ? link.color : (isDarkTheme ? 'white' : 'black')}
                    className="transition-colors duration-300"
                  />
                </motion.div>
              </a>
              <motion.p 
                className="mt-2 text-center text-sm"
                initial={{ opacity: 0 }}
                animate={{ opacity: hoveredIcon === link.name ? 1 : 0 }}
                transition={{ duration: 0.2 }}
              >
                {link.name}
              </motion.p>
            </motion.div>
          ))}
        </div>

        <motion.div
          className="max-w-2xl text-center px-4"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 1, duration: 0.5 }}
        >
          <h2 className="text-2xl sm:text-3xl font-semibold mb-4">Why Connect?</h2>
          <ul className="list-disc list-inside text-left space-y-2 text-sm sm:text-base">
            <li>Stay updated on my latest projects and achievements</li>
            <li>Get insights into my professional journey and experiences</li>
            <li>Engage in meaningful discussions about technology and innovation</li>
            <li>Explore potential collaboration opportunities</li>
          </ul>
        </motion.div>

        <motion.div
  className="max-w-4xl w-full mt-12"
  initial={{ opacity: 0, y: 20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ delay: 1.2, duration: 0.5 }}
>
  <h2 className="text-2xl sm:text-3xl font-semibold mb-6 text-center">Explore My Design World</h2>
  <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-6">
    {designAccounts.map((account, index) => (
      <DesignCard key={index} {...account} />
    ))}
  </div>
</motion.div>
      </div>
    </div>
  );
};

export default Socialize;